import { render, staticRenderFns } from "./ClassListTab.vue?vue&type=template&id=535b7f62"
import script from "../../services/teacher/class-tab.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/class-tab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports